import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { FinanceDisbursementAccountResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post, postEmpty } from "./common";

export const financeDisbursementAccount = {
    record(data: typeof Requests.FinanceDisbursementAccount.Record.Input) {
        return post<typeof data, FinanceDisbursementAccountResponseTypes.Record>(
            `/finance-disbursement-account/record`,
            data,
        );
    },
    transactionRecord(id: string) {
        return (data: typeof Requests.FinanceDisbursementAccount.TransactionRecord.Input) => {
            return post<typeof data, FinanceDisbursementAccountResponseTypes.TransactionRecord>(
                `/finance-disbursement-account/transaction-record/${id}`,
                data,
            );
        };
    },
    create(data: typeof Requests.FinanceDisbursementAccount.Create.Input) {
        return post<typeof data>(`/finance-disbursement-account/create`, data);
    },
    obtain(id: string) {
        return get<FinanceDisbursementAccountResponseTypes.Obtain>(
            `/finance-disbursement-account/obtain/${id}`,
        );
    },
    delete(id: string) {
        return postEmpty(`/finance-disbursement-account/delete/${id}`);
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<FinanceDisbursementAccountResponseTypes.Select>(
                `/finance-disbursement-account/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.FinanceDisbursementAccount.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/finance-disbursement-account/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
